import React from 'react';

/**
 * Displays a success notification message 
 */
const SuccessNotification = ({ message, onClose }) => {
  return (
    <div className="success-notification">
      <span>{message}</span>
      <button onClick={onClose}>×</button>
    </div>
  );
};

export default SuccessNotification; 